import { InMemoryCache } from "@apollo/client";

function offsetLimitPageInfoPagination(keyArgs = false) {
  return {
    keyArgs: keyArgs,
    merge(existing, incoming, { args }) {
      existing = existing ?? {
        data: [],
        pageInfo: {},
      };
      incoming = incoming ?? {
        data: [],
        pageInfo: {},
      };
      const { data: existingData, pageInfo: existingPageInfo } = existing;
      const { data: incomingData, pageInfo: incomingPageInfo } = incoming;
      let merged = existingData ? existingData.slice(0) : [];
      if (args) {
        const { offset = 0, limit } = args;
        merged = existingData
          ? existingData.slice(0, (offset + 1) * limit)
          : [];
        for (let i = 0; i < incomingData.length; ++i) {
          merged[offset + i] = incomingData[i];
        }
      } else {
        merged = merged.concat(incomingData);
      }
      const pageInfo = (() => {
        if (args) {
          const { offset = 0 } = args;
          if (offset === incomingPageInfo?.offset) {
            return incomingPageInfo;
          } else if (offset === existingPageInfo?.offset) {
            return existingPageInfo;
          }
        } else {
          return incomingPageInfo;
        }
      })();
      return { data: merged, pageInfo };
    },
  };
}
const cache = () => {
  return new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          channels: offsetLimitPageInfoPagination(["filter", "sort"]),
          channelsWithContractStatus: offsetLimitPageInfoPagination([
            "filter",
            "sort",
            "uuid",
          ]),
          channelFeatureEpisodes: offsetLimitPageInfoPagination(["id"]),
          storeEpisodes: offsetLimitPageInfoPagination(["filter", "sort"]),
          paletteObjects: offsetLimitPageInfoPagination(["id"]),
          children: offsetLimitPageInfoPagination(["id", "filter", "sort"]),
          canvas: offsetLimitPageInfoPagination(["idKey"]),
          channelEpisodeSearch: offsetLimitPageInfoPagination([
            "id",
            "keyword",
            "episodeType",
          ]),
          channelLiveSchedule: offsetLimitPageInfoPagination(["id", "day"]),
          channelLinearEpisodes: offsetLimitPageInfoPagination(["id"]),
          search: offsetLimitPageInfoPagination(["keyword", "filter", "sort"]),
          searchTvShow: offsetLimitPageInfoPagination([
            "keyword",
            "filter",
            "sort",
          ]),
          informations: offsetLimitPageInfoPagination(["key"]),
          favoritesByContentType: offsetLimitPageInfoPagination(["type"]),
          getEntitledStoreEpisodes: offsetLimitPageInfoPagination(),
          viewingHistories: offsetLimitPageInfoPagination(["sort"]),
          orders: offsetLimitPageInfoPagination(["year"]),
          genrePaletteEpisodes: offsetLimitPageInfoPagination([
            "channel",
            "genre",
            "sortOrder",
            "type",
          ]),
          titles: offsetLimitPageInfoPagination(["filter", "sort"]),
        },
      },
      AccountUser: {
        keyFields: ["uuid"],
      },
      Palette: {
        keyFields: ["palette_id"],
      },
      PaletteObject: {
        keyFields: ["type", "id"],
      },
      Term: {
        keyFields: ["id_key"],
      },
      TermRevision: {
        keyFields: ["unique_key"],
      },
      TermAgreement: {
        keyFields: ["agreement_id"],
      },
      CanvasStructure: {
        keyFields: ["type", "id"],
      },
    },
  });
};

export default cache;
